/**
 * STUDIO IDENTITY — the single place the studio's own name, domain and contact
 * details are written.
 *
 * All new positioning copy on this site is deliberately brand-neutral: it names
 * what we do, never who we are. The studio name appears only in navigation, the
 * footer, metadata and this file. When the brand and domain change, change them
 * here (plus the logo asset, the build-time SEO plugin constants and the public
 * text files in /public) rather than rewriting page copy.
 */

export const STUDIO_NAME = 'Academy Legacy';

/** Wordmark split for the footer lockup: line one, then the italic gold line. */
export const STUDIO_WORDMARK = { lead: 'Academy', accent: 'Legacy.' };

/** Initials used as the oversized decorative watermark on hero and CTA sections. */
export const STUDIO_MARK = 'AL';

export const STUDIO_DOMAIN = 'www.academy-legacy.com';
export const STUDIO_URL = 'https://www.academy-legacy.com';
export const STUDIO_EMAIL = 'info@academy-legacy.com';
export const STUDIO_INSTAGRAM = { handle: '@academylegacy_', url: 'https://instagram.com/academylegacy_' };
export const STUDIO_LOCATION = { locality: 'London', country: 'UK' };

/**
 * What we do, in one sentence. Shown in the footer on every page.
 *
 * Leads with the redesign and stops there. The client experience layer is a
 * real second service with its own page, but naming it in a one-line summary
 * split the message, so the summary stays on the thing people arrive for.
 */
export const STUDIO_TAGLINE =
  'We redesign websites. From a blank page, around what you actually sell, and you see it finished before there is anything to commit to.';
